require('./wpAjax');
require('./callToAction');
require('./listView');
require('./jquery.simplePagination');
require('./main');